import React from 'react';
import { MoonIcon, StarIcon } from 'lucide-react';
export function DecorativeDivider() {
  return <div className="flex items-center justify-center space-x-4 py-6 md:py-10 opacity-40 text-gold" data-id="element-300">
      <div className="h-px w-12 md:w-16 bg-gold/50 rounded-full" data-id="element-301"></div>
      <StarIcon className="w-3 h-3 md:w-4 md:h-4 fill-current" data-id="element-302" />
      <MoonIcon className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-303" />
      <StarIcon className="w-3 h-3 md:w-4 md:h-4 fill-current" data-id="element-304" />
      <div className="h-px w-12 md:w-16 bg-gold/50 rounded-full" data-id="element-305"></div>
    </div>;
}